// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1XlP2","content":"RecentSearches_content__28Rto"};